import React, { useEffect, useState } from "react";
import { Row, Col, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "../lib/axios";
import { BrowserView, MobileView } from "react-device-detect";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import {
  STORAGE_URL,
  IMAGES_URL,
  CVTHEQUE_URL,
  BASE_URL,
} from "../lib/constants";
const Entete = () => {
  const { t, i18n } = useTranslation();
  const [add_p1, setAdd_p1] = useState([]);
  const [add_p2, setAdd_p2] = useState([]);
  const [add_p3, setAdd_p3] = useState([]);
  const [add_p4, setAdd_p4] = useState([]);
  const [add_p5, setAdd_p5] = useState([]);
  const [adds, setAdds] = useState([]);

  useEffect(() => {
    const fetchAdds = async () => {
      try {
        const response = await axios.get("/api/adds");
        const data = response.data;
        setAdds(data.adds);
        sessionStorage.setItem("adds", JSON.stringify(data.adds));
      } catch (error) {
        console.error(error);
      }
    };
    if (sessionStorage.getItem("adds") === null) {
      fetchAdds();
    }
    if (sessionStorage.getItem("adds") !== "undefined") {
      const adds = JSON.parse(sessionStorage.getItem("adds"));
      setAdd_p1([]);
      setAdd_p2([]);
      setAdd_p3([]);
      setAdd_p4([]);
      setAdd_p5([]);
      if (adds !== null) {
        adds.map((e) => {
          if (e.position == 1) setAdd_p1((cu) => [...cu, e]);
          if (e.position == 2) setAdd_p2((cu) => [...cu, e]);
          if (e.position == 3) setAdd_p3((cu) => [...cu, e]);
          if (e.position == 4) setAdd_p4((cu) => [...cu, e]);
          if (e.position == 5) setAdd_p5((cu) => [...cu, e]);
        });
      }
    }
  }, [adds]);

  return (
    <div>
      <header>
        <Row style={{ margin: "auto" }}>
          <Col xs={4} sm={4} className="img-in-nav">
            {add_p1.map((a, key) => (
              <p key={key}>
                <a href={a.target} target="_blank" rel="noreferrer">
                  <img
                    loading="lazy"
                    alt="RIMTIC"
                    src={STORAGE_URL + "images/" + a.image}
                  />
                </a>
              </p>
            ))}
          </Col>
          <Col xs={4} sm={4} className="img-in-nav">
            <Link to={`/${i18n.language}/`}>
              <MobileView>
                <img
                  alt="RIMTIC"
                  loading="lazy"
                  src={IMAGES_URL + "logoRIMTIC.png"}
                />
              </MobileView>
              <BrowserView>
                <img
                  alt="RIMTIC"
                  loading="lazy"
                  src={IMAGES_URL + "logoRIMTIC.png"}
                  style={{ width: "70%" }}
                />
              </BrowserView>
            </Link>
          </Col>
          <Col xs={4} sm={4}>
            {add_p2.map((a, key) => (
              <p key={key}>
                <a href={a.target} target="_blank" rel="noreferrer">
                  <img
                    alt="RIMTIC"
                    loading="lazy"
                    src={STORAGE_URL + "images/" + a.image}
                  />
                </a>
              </p>
            ))}
          </Col>
        </Row>

        <Navbar
          expand="lg"
          style={{ justifyContent: "center", display: "grid", padding: 0 }}
        >
          <div style={{ display: "flex" }}>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
            />

            <Dropdown className="d-block  d-sm-none">
              <Dropdown.Toggle
                className="btn-langue"
                variant="success"
                id="dropdown-basic"
              >
                <FontAwesomeIcon icon={faGlobe} style={{ fontSize: "20px" }} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {i18n.language == "fr" ? (
                  <Dropdown.Item
                    onClick={() => {
                      if (
                        !window.location.href.includes("/ar/") &&
                        !window.location.href.includes("/fr/")
                      ) {
                        i18n.changeLanguage("ar");
                        window.location.href = window.location.href + "ar/";
                      } else {
                        window.location.href = window.location.href.replace(
                          "/fr/",
                          "/ar/",
                        );
                      }
                    }}
                    className="fontAlmari"
                    style={{
                      color: "black",
                      fontWeight: "700",
                      textTransform: "uppercase",
                      fontFamily: "Almarai",
                    }}
                  >
                    العربية
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    onClick={() => {
                      if (
                        !window.location.href.includes("/ar/") &&
                        !window.location.href.includes("/fr/")
                      ) {
                        i18n.changeLanguage("fr");
                        window.location.href = window.location.href + "fr/";
                      } else {
                        window.location.href = window.location.href.replace(
                          "/ar/",
                          "/fr/",
                        );
                      }
                    }}
                    className="fontAlmari"
                    style={{
                      color: "black",
                      fontWeight: "700",
                      textTransform: "uppercase",
                    }}
                  >
                    Francais
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                eventKey="1"
                className="fontAlmari"
                as={Link}
                to={`/${i18n.language}/`}
              >
                {t("accueil")}
              </Nav.Link>

              <NavDropdown
                className="fontAlmari"
                title={t("entreprises")}
                id="e-nav"
              >
                <NavDropdown.Item
                  eventKey="2"
                  as={Link}
                  to={`/${i18n.language}/deposer_offre_emploi`}
                >
                  {t("depose_offre_emploi")}
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="3"
                  as={Link}
                  to={`/${i18n.language}/deposer_appel_offres`}
                >
                  {" "}
                  {t("depose_appel_offre")}{" "}
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4"
                  as={Link}
                  to={`/${i18n.language}/deposer_avis`}
                >
                  {t("depose_avis")}
                </NavDropdown.Item>
                <NavDropdown.Item eventKey="6" as={Link} to="/article/1">
                  {t("menu_hr_solutions")}
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                className="fontAlmari"
                title={t("candidats")}
                id="c-nav"
              >
                <NavDropdown.Item
                  eventKey="6"
                  href={CVTHEQUE_URL + "/inscrire"}
                >
                  {t("deposer_votre_CV")}{" "}
                </NavDropdown.Item>
                <NavDropdown.Item eventKey="7" href={CVTHEQUE_URL + "/profile"}>
                  {t("gerer_votre_CV")}{" "}
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                className="fontAlmari"
                title={t("modele")}
                id="c-nav"
              >
                <NavDropdown.Item eventKey="8" as={Link} to="/modelesCV">
                  {t("CVs")}
                </NavDropdown.Item>
                <NavDropdown.Item eventKey="9" as={Link} to="/modelesLettres">
                  {t("lettres_de_motivation")}
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                eventKey="10"
                className="fontAlmari"
                as={Link}
                to="/contact"
              >
                {t("contact")}
              </Nav.Link>

              <Nav.Link style={{ height: "90%" }} as={Link} to="/contact">
                <img
                  src={BASE_URL + "/dgMarket-Mauritanie.gif"}
                  alt="dgMarket - Mauritanie"
                />
              </Nav.Link>

              {i18n.language == "fr" ? (
                <Nav.Link
                  eventKey="11"
                  onClick={() => {
                    if (
                      !window.location.href.includes("/ar/") &&
                      !window.location.href.includes("/fr/")
                    ) {
                      i18n.changeLanguage("ar");
                      window.location.href = window.location.href + "ar/";
                    } else {
                      window.location.href = window.location.href.replace(
                        "/fr/",
                        "/ar/",
                      );
                    }
                  }}
                  className="fontAlmari d-none d-lg-block"
                  style={{
                    color: "black",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    fontFamily: "Almarai",
                  }}
                >
                  {" "}
                  العربية
                </Nav.Link>
              ) : (
                <Nav.Link
                  eventKey="11"
                  onClick={() => {
                    if (
                      !window.location.href.includes("/ar/") &&
                      !window.location.href.includes("/fr/")
                    ) {
                      i18n.changeLanguage("fr");
                      window.location.href = window.location.href + "fr/";
                    } else {
                      window.location.href = window.location.href.replace(
                        "/ar/",
                        "/fr/",
                      );
                    }
                  }}
                  className="fontAlmari d-none d-lg-block "
                  style={{
                    color: "black",
                    fontWeight: "700",
                    textTransform: "uppercase",
                  }}
                >
                  Francais
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Row className="middle-menu center-text" style={{ margin: "auto" }}>
          {add_p3.length !== 0 && (
            <Col xs={12} sm={12} className="img-in-nav">
              {add_p3.map((a, key) => (
                <p key={key}>
                  <a href={a.target} target="_blank" rel="noreferrer">
                    <img
                      alt="RIMTIC"
                      src={STORAGE_URL + "images/" + a.image}
                      style={{ height: "100px", width: "100%" }}
                    />
                  </a>
                </p>
              ))}
            </Col>
          )}
          {add_p4.length !== 0 && (
            <Col xs={12} sm={12} className="mt-2 pb-2">
              <div className="scroll-container">
                <div className="scroll-content">
                  {add_p4.map((a, key) => (
                    <p key={key}>
                      <a href={a.target} target="_blank" rel="noreferrer">
                        <img
                          src={STORAGE_URL + "images/" + a.image}
                          style={{ height: "40px", width: "auto" }}
                        />
                        <span className="ms-2 fontAlmari"> {a.text} </span>
                      </a>
                    </p>
                  ))}
                </div>
              </div>
            </Col>
          )}
        </Row>
      </header>
    </div>
  );
};

export default Entete;
